export default "__VITE_ASSET__BbnYT4dy__"